<template>
  <div>
    <!--searchMenu-->
    <v-navigation-drawer
      v-model="showSearchMenu"
      right
      absolute
      class="searchMenuBackground"
      id="searchMenu"
    >
      <v-tabs v-model="tab" mobile-break-point="0">
        <v-tab v-if="tab1.enabled">
          <v-icon>{{ tab1.icon }}</v-icon>
        </v-tab>
        <v-tab v-if="tab2.enabled">
          <v-icon>{{ tab2.icon }}</v-icon>
        </v-tab>
        <v-tab v-if="tab3.enabled">
          <v-icon>{{ tab3.icon }}</v-icon>
        </v-tab>

        <v-btn icon class="btnMenuSearch" @click="close()" max-width="40">
          <v-icon id="search-menu-component-items-icon">fas fa-times</v-icon>
        </v-btn>
      </v-tabs>

      <v-tabs-items v-model="tab" dark>
        <v-tab-item>
          <v-form
          ref="form"
          v-model="valid">
            <v-list dense>
              <search-item :label="$t('SearchItem.ShipmentNumber')" ref="searchShipmentNumber" :itemValue="shipmentNumberItemValue"
              style="height: 58px"
              v-on:itemValueChange="shipmentNumberItemChanged"></search-item>

              <!--BUTTONS-->
              <v-list-item style="padding-top: 10px" class="listItemSearchMenu">
                <v-list-item-content></v-list-item-content>
                <v-list-item-content>
                  <v-btn
                    class="white--text searchMenuButtonLeft"
                    @click="search(true)"
                  >
                    <v-icon left>fas fa-search</v-icon>
                    {{ $t("SearchMenu.Button.Search") }}
                  </v-btn>
                </v-list-item-content>
                <v-list-item-content>
                  <v-btn
                    @click="reset()"
                    class="searchMenuButtonRight"
                    color="#FFFFFF"
                  >
                    <v-icon left>fas fa-eraser</v-icon>
                    {{ $t("SearchMenu.Button.Reset") }}
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-form>
        </v-tab-item>

        <v-tab-item> Tab 2 </v-tab-item>

        <v-tab-item> Tab 3 </v-tab-item>
      </v-tabs-items>
    </v-navigation-drawer>
  </div>
</template>
<script>

import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";
import searchItem from "../components/searchItemComponent.vue";

export default {

  components: { searchItem },

  props: {
    showSearchMenu: Boolean,
    tab1: {
      enabled: { type: Boolean, default: true },
      icon: { type: String, default: "fas fa-external-link-alt" },
    },
    tab2: {
      enabled: { type: Boolean, default: true },
      icon: { type: String, default: "fas fa-external-link-alt" },
    },
    tab3: {
      enabled: { type: Boolean, default: true },
      icon: { type: String, default: "fas fa-external-link-alt" },
    },
  },

  data: vm => ({
    valid: true,
    tab: null,  
    load: false,
    startDate: new Date().toISOString().substr(0, 10),
    startDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    endDate: new Date().toISOString().substr(0, 10),
    endDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),  
    shipmentNumberItemValue: { value: "", valueType: "StartWith"},
    localStorageItemId: "app_savedSearchParams",
    localStorageItemGridId: "app_savedSearchParamsGrid",
  }),

  watch: {
    menuStartDate: {
      handler(newVal) {
        this.load = true;
      }
    },
    startDate(val) {
      this.startDateFormatted = this.formatDate(this.startDate);
    },
    endDate(val) {
      this.endDateFormatted = this.formatDate(this.endDate);
    }
  },

  mounted() {
    let savedSearchParams = localStorage.getItem(this.localStorageItemId);
    // console.log("get", JSON.parse(localStorage.getItem(this.localStorageItemId)));
    if (
      localStorage.getItem(this.localStorageItemId) == "null" ||
      !localStorage.getItem(this.localStorageItemId)
    ) {
      this.setDefaultValues();
    } else {
      this.setSavedValues(localStorage.getItem(this.localStorageItemId));
    }
  },

  methods: {
    shipmentNumberItemChanged(value) {
      this.shipmentNumberItemValue = value;
    },
    setDefaultValues() {
      
      var startDefaultDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        new Date().getDate()
      );

      this.startDate =
        startDefaultDate.getFullYear() +
        "-" +
        ("0" + (Number(startDefaultDate.getMonth()) + Number(1))).slice(-2) +
        "-" +
        ("0" + startDefaultDate.getDate()).slice(-2);

      this.endDate = "";
            
      this.shipmentNumberItemValue = { value: "", valueType: "Equal"};
    },
    setSavedValues(values) {
      let values_parsed = JSON.parse(values);
      
      this.startDate = values_parsed.startDate;
      this.endDate = values_parsed.endDate;
      
      this.clientCodeItemValue= {value: values_parsed.ClientCodeValue, valueType: values_parsed.ClientCodeType};
      this.shipmentNumberItemValue= {value: values_parsed.ShipmentNumberValue, valueType: values_parsed.ShipmentNumberType};
      this.trafficType = values_parsed.TrafficType;
      
      // console.log("set saved values", values_parsed, "traffictype", values_parsed.trafficType, "set", this.trafficType);        
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    search(redirect) {

     },
    reset() {
      this.setDefaultValues();
      this.search(false);      
    },
    close() {
      let showSM = {
        show: false,
        style: "color: #cecece",
      };

      this.$store.commit("SET_showSearchMenu", showSM);
    },
  },
};
</script>